import React, { Component } from "react";
// import qr from "../images/qr.jpeg"
import { withNavigation } from "../withNavigation";
import "../styles/deposit.css";
class Deposit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      amount: "",
      utrNo: ""
    };
  }

  componentDidMount() {
    let user = this.props.location?.state?.user;

    if (!user) {
      const stored = localStorage.getItem("user");

      if (stored) { user = JSON.parse(stored); }
    }

    if (!user) {
      this.props.navigate("/");
      return;
    }

    this.setState({ user });

  }



  submitRequest = async () => {
    const { amount, utrNo, user } = this.state;

    if (
      !amount || Number(amount) <= 0 || !utrNo) {
      alert(
        "Enter Amount & UTR"
      );
      return;
    }


    const res = await fetch("https://api.hi-bigame.online/deposit-request",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
             Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          userId: user.id,
          amount,
          utrNo
        })
      }
    );


    const data = await res.json();
    alert(data.message);

    if (data.success) { this.props.navigate("/home", { state: { user } }); }

  };

  render() {

    return (

      <div><div className="deposit-container">

        <div className="deposit-card">

          <h1 className="deposit-title">💰 Deposit</h1>

          <input type="number" placeholder="Enter Amount" value={this.state.amount} onChange={(e) =>
            this.setState({ amount: e.target.value })} className="deposit-input" />

          <input type="text" placeholder="Enter UTR Number" value={this.state.utrNo} onChange={(e) =>
            this.setState({ utrNo: e.target.value })} className="deposit-input" />

          <button className="submit-btn" onClick={this.submitRequest} > Submit</button>

          <button className="back-btn" onClick={() => this.props.navigate("/home",
            { state: { user: this.state.user } })}> Back</button>
        </div>

      </div>

      </div>
    );

  }

}
export default withNavigation(Deposit);